exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".down-Arrow {\n  transform: rotate(0deg);\n}\n.up-Arrow {\n  transform: rotate(-180deg);\n}\n.question {\n  border-bottom: 1px solid #e2e8f0;\n}\n", ""]);

// exports
